import api from './axiosInstance';

export const getReferralsApi    = (params) => api.get('/admin/users/referrals', { params });
export const getWalletApi       = (params) => api.get('/user/wallet', { params });
export const redeemRewardsApi   = (data)   => api.post('/redeem-referral-rewards', data);
export const getPlansApi        = ()       => api.get('/plans');
